import { ReviewStatusSchema as o, LandingIdSchema as p, CreativeIdSchema as h, ImageTypeSchema as U, CreativeTypeSchema as C, FilenameSchema as Z, MediaUrlSchema as ee, CustomContentUrlSchema as te, CustomContentSchema as ne, CreativeVariationWeightSchema as V, AssetStatusSchema as T, AdTypeSchema as i, AssetIdSchema as D, CreativeGroupIdSchema as ae, AdFormatSchema as oe, CampaignGroupIdSchema as ie, AdFormatIdSchema as re, AdTypeIdSchema as se, OnOffSchema as ce, NumericIdSchema as me, UserIdSchema as d, LandingGroupIdSchema as g } from "@hprofits/shared";
import { hasValue as de } from "@hprofits/utils/fp/optional";
import { z as e } from "zod";
import { createViewSchemas as I } from "../common/acl-view.js";
import "@hprofits/utils";
import "@orpc/contract";
import "@orpc/openapi";
import "../swagger/security.js";
import "../swagger/tags.js";
import { OwnerSchema as c } from "../common/owner.js";
import "../common/params.js";
import { PaginationSchema as A, SortingSchema as L, paginatedList as R } from "../common/pagination.js";
const _ = 50, M = e.string().trim().min(1, "name must be non-empty").max(_, `name must be at most ${_} characters`), le = e.string().trim().min(1, "name must be non-empty"), pe = 15, S = e.string().min(pe), y = e.enum(["Fraud", "DontWork"]), B = e.object({
  rejectReason: y,
  rejectDescription: S.optional()
}), St = e.record(y, e.string()), b = e.enum(["Misleading", "LowQuality", "Suspicious", "BadAds"]), O = e.object({
  rejectReason: b,
  rejectDescription: S.optional()
}), yt = e.record(b, e.string()), ue = e.object({
  id: p,
  url: e.string(),
  // z.url(),
  status: o,
  rejection: B.optional()
}).readonly(), F = e.enum(["file", "customUrl", "customHtml"]), he = e.object({
  id: h,
  name: e.string(),
  size: e.string().optional(),
  // TODO: Banner Size - maybe it will be better to rename and use enum here
  content: e.union([ee, te, ne]).optional(),
  contentKind: F,
  status: o,
  title: e.string().optional(),
  description: e.string().optional(),
  brandTitle: e.string().optional(),
  tagIds: e.array(e.number()).optional(),
  originalFilename: Z.optional(),
  sizeBytes: e.number().optional(),
  creativeType: C.optional(),
  imageType: U.optional(),
  owner: c,
  rejection: O.optional()
}).readonly(), ge = e.object({
  reviewer: c.optional()
}).readonly(), {
  common: bt,
  admin: vt,
  union: Se
} = I(he, ge), ye = e.object({
  id: D,
  adType: i,
  status: T,
  weight: V,
  creative: Se.optional(),
  landing: ue.optional()
}).readonly(), be = e.object({
  creativeId: h.optional(),
  landingId: p.optional(),
  weight: V.optional()
}).strict().readonly(), Ct = be.unwrap().extend({
  id: D
}).readonly(), P = e.object({
  id: ae,
  name: le,
  status: T
}), ve = e.record(T, e.number().int().nonnegative()), Ce = P.extend({
  campaignId: ie,
  adType: i,
  adFormat: oe,
  autoRotateIsEnabled: e.boolean(),
  fraudulentTrafficUrl: e.string().min(1).optional(),
  assets: e.array(ye).readonly(),
  customContentAllowed: e.boolean()
}).readonly(), Te = e.object({
  rotatorIndex: e.string().min(1).optional()
}).readonly(), {
  common: Tt,
  admin: It,
  union: At
} = I(Ce, Te), Ie = P.extend({
  assetsCount: e.number().int().nonnegative(),
  detailedStatus: ve
}).readonly(), Lt = e.array(Ie).readonly(), z = e.object({
  name: M,
  status: ce,
  type: se,
  format: re,
  autoRotateIsEnabled: e.boolean().optional(),
  fraudulentTrafficUrl: e.string().trim().min(1).optional()
}).strict(), w = 100, H = e.object({
  rotatorIndex: e.string().trim().min(1).max(w, `rotator index must be ${w} characters or less`).optional()
}), Ae = z.readonly(), Le = z.extend(H.shape).readonly(), Rt = e.union([Ae, Le]).readonly(), K = e.object({
  autoRotateIsEnabled: e.boolean().optional(),
  fraudulentTrafficUrl: e.string().trim().min(1).optional()
}).strict(), Re = K.readonly(), Ge = K.extend(H.shape).readonly(), Gt = e.union([Re, Ge]).readonly(), jt = e.object({
  name: M
}).readonly(), G = e.object({
  id: p,
  status: o
}).strict(), je = G.extend({
  status: e.literal(o.enum.Approved)
}), fe = G.extend(B.required().shape).extend({
  status: e.literal(o.enum.Rejected)
}), Ee = G.extend({
  status: e.literal(o.enum.Reviewing),
  reason: S
}), ft = e.discriminatedUnion("status", [je, fe, Ee]).readonly(), j = e.object({
  id: h,
  status: o
}).strict(), _e = j.extend({
  status: e.literal(o.enum.Approved)
}), we = j.extend({
  status: e.literal(o.enum.Reviewing),
  reason: S
}), Ne = j.extend(O.required().shape).extend({
  status: e.literal(o.enum.Rejected)
}), Et = e.discriminatedUnion("status", [_e, Ne, we]).readonly(), r = me.brand("AdTag"), _t = A.extend(L.shape).extend({
  id: e.array(e.coerce.number().pipe(h)).optional(),
  description: e.string().optional(),
  userId: e.array(e.coerce.number().pipe(d)).optional(),
  status: e.array(o).optional(),
  type: e.array(C).optional(),
  adType: e.array(i).optional(),
  adTags: e.array(e.coerce.number().pipe(r)).optional(),
  width: e.coerce.number().int().positive().optional(),
  height: e.coerce.number().int().positive().optional(),
  reject: e.array(b).optional(),
  labels: e.array(e.coerce.number().int()).optional(),
  uniqKey: e.string().optional()
}).readonly(), X = e.object({
  id: h,
  title: e.string().optional(),
  description: e.string().optional(),
  brandTitle: e.string().optional(),
  adType: i,
  creativeType: C.optional(),
  width: e.number().int().optional(),
  height: e.number().int().optional(),
  adTags: e.array(r).optional(),
  labelIds: e.array(e.number().int()).optional(),
  sizeBytes: e.number().int().nonnegative().optional(),
  mediaUrl: e.string().optional(),
  // The three content columns stay separate here (unlike `content` on the creative view), but which
  // one a creative carries still comes from the producer — a consumer re-deriving it drifts (#853).
  // Custom content is what the creative IS, so every persona that may pick the creative sees it.
  customContent: e.string().optional(),
  customContentUrl: e.string().optional(),
  contentKind: F,
  imageType: U.optional(),
  status: o,
  owner: c,
  uniqKey: e.string().optional(),
  rejectReason: b.optional(),
  rejectDescription: e.string().optional(),
  customContentAllowed: e.boolean()
}), xe = X.readonly(), Ue = X.extend({
  reviewer: c.optional()
}).superRefine((t, n) => {
  !t.customContent && !t.customContentUrl && !t.mediaUrl && n.addIssue("at least one of customContent or mediaUrl must be specified"), de(t.mediaUrl) && t.sizeBytes === 0 && n.addIssue("size must be positive if mediaUrl is used");
}).readonly(), {
  common: wt,
  admin: Nt,
  union: Ve
} = I(xe, Ue), xt = R(Ve), De = 50, Me = 200, Be = 25, N = {
  title: De,
  description: Me,
  brandTitle: Be
}, Oe = ["title", "description", "brandTitle"], Fe = /https?:\/\//, Pe = [i.enum.Native, i.enum.Push], $ = (t, n) => Oe.flatMap((a) => {
  const s = n[a] ?? "", l = [];
  return Fe.test(s) && l.push({ field: a, code: "link", message: `${a} must not contain a link` }), Pe.includes(t) && s.length > N[a] && l.push({
    field: a,
    code: "tooLong",
    message: `${a} must be at most ${N[a]} characters`
  }), t === i.enum.Native && s.length === 0 && l.push({ field: a, code: "required", message: `${a} is required for a native creative` }), l;
}), ze = 64, u = e.number().int().positive(), He = e.object({
  id: u,
  name: e.string()
}).readonly(), Ut = e.array(He).readonly(), Vt = e.object({
  name: e.string().trim().min(1).max(ze)
}).readonly(), Dt = e.object({
  file: e.file(),
  adType: i,
  title: e.string().optional(),
  description: e.string().optional(),
  brandTitle: e.string().optional(),
  // Multipart fields arrive as text, hence the coercion.
  adTags: e.array(e.coerce.number().pipe(r)).optional(),
  labelIds: e.array(e.coerce.number().pipe(u)).optional(),
  ownerId: e.coerce.number().pipe(d).optional()
}).superRefine((t, n) => {
  for (const { field: a, message: s } of $(t.adType, t))
    n.addIssue({ code: "custom", path: [a], message: s });
}).readonly(), k = 1e5, Mt = e.object({
  title: e.string().optional(),
  description: e.string().optional(),
  brandTitle: e.string().optional(),
  adTags: e.array(r).optional(),
  labelIds: e.array(u).optional(),
  content: e.string().trim().min(1).max(k).optional()
}).readonly(), Ke = [
  i.enum.Banner,
  i.enum.Video,
  i.enum.VideoSlider,
  i.enum.OutstreamVideo
], m = e.enum(["html", "vast", "url"]), Xe = [
  m.enum.html,
  m.enum.url
], $e = [
  m.enum.vast,
  m.enum.url
], ke = /<[a-z]/i, qe = /<VAST[\s>]/i, Qe = (t) => {
  const n = ke.exec(t);
  return n !== null && t.includes(">", n.index + n[0].length);
}, We = (t, n) => t === m.enum.html ? Qe(n) : t === m.enum.vast ? qe.test(n) : Q.test(n) && e.url().safeParse(n).success, Bt = e.object({
  adType: e.enum(Ke),
  kind: m,
  content: e.string().trim().min(1).max(k),
  description: e.string().optional(),
  adTags: e.array(r).optional(),
  labelIds: e.array(u).optional(),
  bannerSizeId: e.number().int().positive().optional(),
  ownerId: d.optional()
}).superRefine((t, n) => {
  const a = t.adType === i.enum.Banner;
  (a ? Xe : $e).includes(t.kind) ? We(t.kind, t.content) || n.addIssue({ code: "custom", path: ["content"], message: `content is not valid ${t.kind}` }) : n.addIssue({
    code: "custom",
    path: ["kind"],
    message: `${t.kind} content is not accepted for ${t.adType}`
  }), a !== (t.bannerSizeId !== void 0) && n.addIssue({
    code: "custom",
    path: ["bannerSizeId"],
    message: a ? "a banner needs a size" : "only a banner has a size"
  });
  for (const { field: s, message: l } of $(t.adType, { description: t.description }))
    n.addIssue({ code: "custom", path: [s], message: l });
}).readonly(), Ot = A.extend(L.shape).extend({
  id: e.array(e.coerce.number().pipe(p)).optional(),
  name: e.string().optional(),
  userId: e.array(e.coerce.number().pipe(d)).optional(),
  status: e.array(o).optional(),
  algorithm: e.array(e.coerce.number().int()).optional(),
  landingGroup: e.array(e.coerce.number().pipe(g)).optional(),
  landingGroupName: e.string().optional(),
  url: e.string().optional(),
  adTags: e.array(e.coerce.number().pipe(r)).optional(),
  reject: e.array(y).optional(),
  automated: e.preprocess((t) => t === "true" ? !0 : t === "false" ? !1 : t, e.boolean()).optional(),
  labels: e.array(e.coerce.number().int()).optional()
}), Ye = e.object({
  id: g,
  name: e.string().optional(),
  algorithm: e.number().int().optional()
}), q = e.object({
  id: p,
  name: e.string().optional(),
  url: e.string(),
  status: o,
  adTags: e.array(r).optional(),
  createdAt: e.string().optional(),
  landingGroup: Ye.optional(),
  owner: c.optional(),
  reviewer: c.optional(),
  rate: e.number().int().optional(),
  rejectReason: y.optional(),
  rejectDescription: e.string().optional()
}), Je = q.extend({
  labelIds: e.array(e.number().int()).optional()
}).readonly(), Ft = R(Je), x = 100, Q = /^https?:\/\//i, f = e.string().trim().min(1, "url must be non-empty").regex(Q, "url must start with http:// or https://"), E = e.string().trim().min(1, "name must be non-empty").max(x, `name must be at most ${x} characters`), Pt = e.object({
  name: E,
  url: f,
  ownerId: d.optional(),
  adTags: e.array(r).optional(),
  labelIds: e.array(u).optional()
}).readonly(), zt = e.object({
  url: f,
  adTags: e.array(r).optional(),
  labelIds: e.array(u).optional()
}).readonly(), v = { even: 1, percent: 2 }, W = e.union([
  e.literal(v.even),
  e.literal(v.percent)
]), Y = e.object({
  url: f,
  adTags: e.array(r).optional(),
  // A relative weight, not a percentage: the ad server picks by rate / sum of rates. Ignored for Even.
  rate: e.number().int().nonnegative().optional()
}), J = (t, n) => {
  t.algorithm === v.percent && t.landings.forEach((a, s) => {
    a.rate || n.addIssue({
      code: "custom",
      path: ["landings", s, "rate"],
      message: "rate must be greater than 0 for the Percent algorithm"
    });
  });
}, Ze = e.object({
  name: E,
  algorithm: W,
  ownerId: d.optional(),
  landings: e.array(Y).min(1, "a landing group needs at least one landing")
}), Ht = Ze.superRefine(J).readonly(), et = e.object({
  name: E,
  algorithm: W,
  landings: e.array(Y.extend({ id: p.optional() })).min(1, "a landing group needs at least one landing")
}), Kt = et.superRefine(J).readonly(), tt = e.enum(["id", "name", "createdAt"]), Xt = A.extend(L.shape).extend({
  sortBy: tt,
  id: e.array(e.coerce.number().pipe(g)).optional(),
  name: e.string().optional(),
  userId: e.array(e.coerce.number().pipe(d)).optional(),
  algorithm: e.array(e.coerce.number().int()).optional()
}), nt = q.pick({
  id: !0,
  name: !0,
  url: !0,
  status: !0,
  rate: !0,
  adTags: !0,
  rejectReason: !0,
  rejectDescription: !0
}).readonly(), at = e.object({
  id: g,
  name: e.string().optional(),
  algorithm: e.number().int().optional(),
  createdAt: e.iso.datetime({ offset: !0 }),
  owner: c.optional(),
  landings: e.array(nt).readonly()
}).readonly(), $t = R(at);
export {
  ze as ADVERT_LABEL_NAME_MAX_LENGTH,
  r as AdTagSchema,
  u as AdvertLabelIdSchema,
  Ut as AdvertLabelListSchema,
  He as AdvertLabelSchema,
  ge as ApiCreativeAdminFieldsSchema,
  vt as ApiCreativeAdminViewSchema,
  he as ApiCreativeCommonFieldsSchema,
  bt as ApiCreativeCommonViewSchema,
  Se as ApiCreativeViewSchema,
  ue as ApiLandingViewSchema,
  ye as AssetViewSchema,
  Be as CREATIVE_BRAND_TITLE_MAX_LENGTH,
  Me as CREATIVE_DESCRIPTION_MAX_LENGTH,
  _ as CREATIVE_GROUP_NAME_MAX_LENGTH,
  De as CREATIVE_TITLE_MAX_LENGTH,
  Ke as CUSTOM_CONTENT_AD_TYPES,
  k as CUSTOM_CONTENT_MAX_LENGTH,
  Vt as CreateAdvertLabelSchema,
  be as CreateAssetSchema,
  Le as CreateCreativeGroupAdminSchema,
  Ae as CreateCreativeGroupCommonSchema,
  Rt as CreateCreativeGroupSchema,
  Nt as CreativeAdminItemSchema,
  wt as CreativeCommonItemSchema,
  F as CreativeContentKindSchema,
  Dt as CreativeCreateSchema,
  Bt as CreativeCustomContentCreateSchema,
  It as CreativeGroupAdminViewSchema,
  Tt as CreativeGroupCommonViewSchema,
  ve as CreativeGroupDetailedStatus,
  Ie as CreativeGroupListItemSchema,
  Lt as CreativeGroupListSchema,
  At as CreativeGroupViewSchema,
  Ve as CreativeListItemSchema,
  _t as CreativeListQuerySchema,
  xt as CreativeListSchema,
  b as CreativeRejectReasonSchema,
  yt as CreativeRejectReasonsDictionarySchema,
  O as CreativeRejectionSchema,
  Et as CreativeReviewSchema,
  Mt as CreativeUpdateSchema,
  m as CustomContentKindSchema,
  v as LANDING_GROUP_ALGORITHM,
  x as LANDING_NAME_MAX_LENGTH,
  Pt as LandingCreateSchema,
  W as LandingGroupAlgorithmSchema,
  Ze as LandingGroupCreateBaseSchema,
  Ht as LandingGroupCreateSchema,
  nt as LandingGroupLandingItemSchema,
  at as LandingGroupListItemSchema,
  Xt as LandingGroupListQuerySchema,
  $t as LandingGroupListSchema,
  tt as LandingGroupSortKeySchema,
  et as LandingGroupUpdateBaseSchema,
  Kt as LandingGroupUpdateSchema,
  Je as LandingListItemSchema,
  Ot as LandingListQuerySchema,
  Ft as LandingListSchema,
  y as LandingRejectReasonSchema,
  St as LandingRejectReasonsDictionarySchema,
  B as LandingRejectionSchema,
  ft as LandingReviewSchema,
  zt as LandingUpdateSchema,
  jt as RenameCreativeGroupSchema,
  Ct as UpdateAssetSchema,
  Ge as UpdateCreativeGroupAdminSchema,
  Re as UpdateCreativeGroupCommonSchema,
  Gt as UpdateCreativeGroupSchema,
  $ as creativeTextIssues,
  We as isCustomContentValid,
  J as validateLandingGroupRates
};
//# sourceMappingURL=schemas.js.map
